import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import cn from 'classnames';
import styles from './CollabWorkspaceScreen.module.sass';
import CollabWorkspace from '../../components/CollabWorkspace';
import 'tippy.js/dist/tippy.css';

const CollabWorkspaceScreen = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  const collaborationId = searchParams.get('id');
  const channelId = searchParams.get('channelId');

  const handleClose = () => {
    // Go back to messages or dashboard
    if (channelId) {
      navigate(`/messages`);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={cn('section', styles.section)}>
      <div className={styles.container}>
        <CollabWorkspace
          collaborationId={collaborationId}
          channelId={channelId}
          onClose={handleClose}
        />
      </div>
    </div>
  );
};

export default CollabWorkspaceScreen;
